
// => Styling
import styles from './Dialog.module.css';


// ============
// Component
// ============
const Dialog = ({
    title = "No title",
    msg = "No message.",
    labelConfirm = "Confirm",
    labelCancel = "Cancel",
    onConfirm = () => {},
    onCancel = () => {},
}) => {


    // RENDER
    // ---------
    return(
        <div className={styles.container}>
            <div className={styles.title}>{title}</div>
            <div className={styles.content}>
                <span className={styles.msg}>{msg}</span>
                <div className={styles.buttons}>
                    <button onClick={onConfirm} className={[styles.btn, styles.primaryBtn].join(" ")}>{labelConfirm}</button>
                    <button onClick={onCancel} className={[styles.btn, styles.secondaryBtn].join(" ")}>{labelCancel}</button>
                </div>
            </div>
        </div>
    );
}


export default Dialog